import { RootState } from 'store/store';

export const selectTechnologyTypesData = (state: RootState) => state.technologyTypes.technologyTypes;
export const selectTechnologyTypesRequestStatus = (state: RootState) =>
  state.technologyTypes.technologyTypesRequestStatus;
